import { render } from "./AppShimmer.vue?vue&type=template&id=dc0f80c4&scoped=true"
import script from "./AppShimmer.vue?vue&type=script&lang=js"
export * from "./AppShimmer.vue?vue&type=script&lang=js"

import "./AppShimmer.vue?vue&type=style&index=0&id=dc0f80c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc0f80c4"]])

export default __exports__